import { render, staticRenderFns } from "./tcmDiagnosis.vue?vue&type=template&id=36d2fbfb&scoped=true"
import script from "./tcmDiagnosis.vue?vue&type=script&lang=js"
export * from "./tcmDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./tcmDiagnosis.vue?vue&type=style&index=0&id=36d2fbfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d2fbfb",
  null
  
)

export default component.exports